module.exports = __webpack_public_path__ + "img/account_circle-24px.fe37ec7e.svg";